import { useState, useEffect } from "react";

export default function Map() {
  const [selected, setSelected] = useState(0);
  const options = ["Glen Rock, NJ", "Paterson, NJ"];

  return (
    <div id="map">
      <h1 className="text-4xl font-bold text-gray-800 mb-4 p-8 flex justify-center">
        Locate a Store Near You
      </h1>
      <div className="w-full max-w-sm mx-auto mt-6">
        {/* Container */}
        <div className="relative bg-gray-200 rounded-full flex p-1">
          {/* Highlight */}
          <div
            className="absolute top-1 bottom-1 left-1 w-1/2 rounded-full bg-white shadow-md transition-transform duration-300 ease-in-out"
            style={{
              transform: `translateX(${selected * 95}%)`,
            }}
          />

          {/* Options */}
          {options.map((city, index) => (
            <button
              key={city}
              onClick={() => setSelected(index)}
              className={`relative z-10 flex-1 flex items-center justify-center text-sm font-semibold py-2 rounded-full transition-colors duration-200 ${
                selected === index
                  ? "text-blue-600"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              {city}
            </button>
          ))}
        </div>
      </div>
      <div className="w-3/4 lg:w-full  max-w-4xl mx-auto rounded-2xl overflow-hidden shadow-lg m-10">
        {selected === 0 ? (
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2640.656225506178!2d-74.14799728905915!3d40.95062712285436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2fd0055cc8e47%3A0x3763bdb45956b81!2sFood%20Universe%20Marketplace!5e1!3m2!1sen!2sus!4v1747074219165!5m2!1sen!2sus"
            className="w-full h-[450px] border-0"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        ) : (
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2642.297071187844!2d-74.14992092461907!3d40.90958302549724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2fd4edf2165a9%3A0x30412b6b8fa904a!2sFood%20Universe%20Marketplace!5e1!3m2!1sen!2sus!4v1747963008686!5m2!1sen!2sus"
            className="w-full h-[450px] border-0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        )}
      </div>
    </div>
  );
}
